import React, { useState, useEffect, useRef } from 'react'
import MuiSvgIcon from '@material-ui/core/SvgIcon';

import {
  EventNoteOutlined,
  ChildCareOutlined,
  AccessibleOutlined,
  AllInclusiveOutlined,
  QueueOutlined,
  LoyaltyOutlined
} from '@material-ui/icons';

const iconMap = {
  'note': EventNoteOutlined,
  'child-care': ChildCareOutlined,
  'accessible': AccessibleOutlined,
  'all-inclusive': AllInclusiveOutlined,
  'queue': QueueOutlined,
  'loyalty': LoyaltyOutlined,
}

export default function SvgIcon(props) {
  const { iconName, ...svgProps } = props;

  const IconRef = useRef(iconMap[props.iconName]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (IconRef.current) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const importIcon = async () => {
      try {
        IconRef.current = (await import(`../../../icons/${iconName}.svg`)).default;
      } catch (err) {
        console.error(`Icon type "${iconName}" provided to SvgIcon component is not mapped.`)
      } finally {
        setLoading(false);
      }
    };
    importIcon();
  }, [props.iconName]);

  if (!loading && IconRef.current) {
    const { current: Icon } = IconRef;
    return <MuiSvgIcon component={Icon} {...svgProps} />;
  }

  return null;
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Svg/SvgIcon.js